<template>
  <div class="direct-pkg-wrap">
    <div class="card-header">
      定向包 <span class="num-text">{{ dataList.length }}/10</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" @click="newDirectPkg">新增</el-button><span class="center-line"></span>
        <el-button icon="el-icon-plus" type="text" @click="selectPkg">选择已有</el-button>
      </div>
    </div>
    <div class="card-list">
      <card-item
        v-for="(item, index) of dataList"
        :key="item.itemId"
        :dataSet="item"
        :title="'新建定向包' + (index + 1)"
        @edit="editItemPkg"
        @copy="copyItemPkg"
        @del="delItemPkg"
        :isCur="curEditId === item.itemId"
        :showDelete="dataList.length > 1"
      ></card-item>
    </div>

    <new-direct-pkg ref="newDirectRef"></new-direct-pkg>

    <checked-modal
      title="选择定向包"
      :tableConf="tableConf"
      :tableData="tableData"
      ref="checkedModalRef"
      @selectOk="selectOk"
    ></checked-modal>
  </div>
</template>

<script>
import CardItem from "./common/cardItem.vue";
import CheckedModal from "./common/checkedModal.vue";
import NewDirectPkg from "./subDirectpkg/newDirectPkg.vue";
import { mapState } from "vuex";
import { getPack } from "@/api/promotion.js";
export default {
  components: {
    CardItem,
    CheckedModal,
    NewDirectPkg,
  },
  data() {
    return {
      tableConf: [
        { title: "定向包名称", colName: "targeting_name" },
        { title: "创建时间", colName: "date" },
      ],
      tableData: [],
      dataList: [],
      curEditId: "", //当前编辑的数据id
    };
  },
  mounted() {
    this.newDirectPkg();
  },
  methods: {
    //编辑定向包
    editItemPkg(dataItem) {
      if (dataItem.itemId === this.curEditId) {
        return;
      } else {
        //编辑切换时只保存到itemcard， 新增复制删除时需要保存到store触发计算（最终的保存在点击预览是校验格式并保存）
        this.saveInItemcard(); //保存当前数据到itemcard后再切换
        this.curEditId = dataItem.itemId;
        this.$refs.newDirectRef.fillData(dataItem);
      }
    },
    copyItemPkg(dataItem) {
      if (this.dataList.length >= 10) {
        return;
      }
      this.saveInItemcard();
      let copyData = JSON.parse(
        //先保存数据后取最新数据
        JSON.stringify(this.dataList.find((item) => item.itemId === dataItem.itemId))
      );
      copyData.itemId = Math.random();
      copyData.targeting_name = copyData.targeting_name + "_复制";
      this.dataList.push(copyData);
      // this.curEditId = copyData.itemId;
      //保存到store
      this.saveInStore();
    },
    delItemPkg(dataItem) {
      let curIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(curIndex, 1);
      //保存到store
      this.saveInStore();
    },
    //新建定向包
    newDirectPkg() {
      if (this.dataList.length >= 10) {
        return;
      }
      let newItem = {
        itemId: Math.random(),
        gender: "GENDER_UNLIMITED",
        ac: [],
        android_osv: "0.0",
        interest_action_mode: "UNLIMITED",
        action_scene: ["E-COMMERCE", "NEWS", "APP", "SEARCH"],
        action_days: "7",
        aweme_fan: "NONE",
        superior_popularity_type: "NONE",
        platform: this.checkedApp.os_type === "ANDROID" ? "ANDROID" : "IOS",
        device_type: [],
        hide_if_exists: "0",
        hide_if_converted: "APP",
        filter_time: "TODAY",
        auto_extend_enabled: 0,
        auto_extend_targets: [],
        aweme_fan_behaviors: [],
        careerType: "NONE", //职业状态
        career: [],
        targeting_name: "新建定向包" + (this.dataList.length + 1),
      };
      this.dataList.push(newItem);
      this.editItemPkg(newItem);
      this.saveInStore();
      //清除自定义媒体包已选数据
      this.$refs.newDirectRef.clearCustomMediaList();
    },
    selectPkg() {
      this.$refs.checkedModalRef.showModal();
      getPack({
        advertiserId: this.adCount[0].advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.tableData = res.targetPacks.map((item) => {
            Object.assign(item, JSON.parse(item.data), {
              date: item.createDate,
            });
            return item;
          });
        }
      });
    },
    selectOk(data) {
      data.forEach((item) => {
        let selectItem = JSON.parse(item.data);
        selectItem.itemId = Math.random();
        this.dataList.push(selectItem);
      });
      this.saveInStore();
    },
    saveInItemcard() {
      //保存到itemCard
      let editData = this.$refs.newDirectRef.formatData();
      let curIndex = this.dataList.findIndex((item) => item.itemId === this.curEditId);
      if (curIndex !== -1) {
        editData.itemId = this.curEditId;
        this.dataList[curIndex] = editData;
      }
      //保存到store
      // this.saveInStore();
    },
    //保存模板时不校验，直接保存
    saveData() {
      this.saveInItemcard(); //保存当前数据后再保存到store
      this.saveInStore();
    },
    saveInStore() {
      let copyData = JSON.parse(JSON.stringify(this.dataList)).map((item) => {
        // delete item.itemId;
        return item;
      });
      this.$store.commit("set_targeting", copyData);
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          this.saveData();
          resolve();
        } else {
          reject();
        }
      });
    },
  },
  computed: {
    ...mapState({
      checkedApp: (state) => state.Promotion.checkedApp,
      targeting: (state) => state.Promotion.draft_adset.targeting,
      adCount: (state) => state.Promotion.adCount,
    }),
  },
  watch: {
    targeting(value) {
      if (value) {
        this.dataList = value.map((item) => {
          // item.itemId = Math.random();
          return item;
        });
        if (value.length > 0) {
          //聚焦最后一个
          this.editItemPkg(value[value.length - 1]);
        }
      }
    },
    curEditId(value) {
      this.$store.commit("set_current_selected_targeting_id", value);
    },
  },
};
</script>

<style lang="less" scoped>
.direct-pkg-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
    .btn-group {
      margin-left: auto;
      .center-line {
        border-left: 1px solid rgba(0, 0, 0, 0.25);
        margin: 0 20px;
      }
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
  .drawer-wrap {
    /deep/.el-drawer__header {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.95);
      font-weight: bold;
      margin-bottom: 22px;
    }
  }
}
</style>
